import React from 'react';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <h2>Your Time. Your Comfort. Your Convenience.</h2>
        <p>Glaminant is a modern beauty service provider dedicated to offering high-quality waxing services in the comfort of your own home. Our mission is to redefine the traditional salon experience by bringing professional care directly to your doorstep—no more long salon queues, no more waiting weeks for an appointment, and no more inconvenience.</p>
        <p>We believe that beauty should be effortless and accessible, which is why we’ve designed our services to prioritize comfort, convenience, and personalized care. Whether you’re a busy professional, a stay-at-home parent, or simply someone who values their time, Glaminant ensures a seamless and hygienic waxing experience without stepping out of your home.</p>
        <p>Let Glaminant be your go-to partner for salon-quality waxing—on your time, at your place, with no compromise.</p>
      </div>
    </section>
  );
};

export default About;